module.exports = __webpack_public_path__ + "img/P63-zh.507e8a61.png";